import { AutoMap } from '@automapper/classes';
import { TBaseModel, TListBaseModel } from './common/t-base.model';
import { FormField } from '../../core/decorators/form-field.decorator';
import { Validators } from '@angular/forms';
import { ReviewSessionStatusEnum } from '../enums/review-session-status.enum';
import { ReviewSessionItemStatusEnum } from '../enums/review-session-item-status.enum';
import {TCommonModel} from './common/t-common-model';
import {INTERNAL_API_KEY_CONSTANTS} from '../../core/constants/internal-api-key.constants';
import {SourceTypeEnum, sourceTypeEnumToGeneralTypeModel} from '../enums/source-type.enum';
import {
  ReviewSessionOrderingTypeEnum,
  reviewSessionOrderingTypeEnumToGeneralTypeModel
} from '../enums/review-session-ordering-type.enum';

export class ReviewSessionListModel extends TListBaseModel {
  @AutoMap()
  isSystemReminder!: boolean;

  @AutoMap()
  status!: ReviewSessionStatusEnum;

  @AutoMap()
  startedOn!: Date;

  @AutoMap()
  completedOn!: Date;

  @AutoMap()
  totalSeen!: number;

  @AutoMap()
  totalReviewed!: number;

  @AutoMap()
  totalSkipped!: number;

  @AutoMap(() => String)
  sourceTitles!: string[];
}


export class ReviewSessionItemModel {
  @AutoMap()
  id!: string;

  @AutoMap()
  highlightId!: string;

  @AutoMap()
  highlightText!: string;

  @AutoMap()
  sourceTitle!: string;

  @AutoMap()
  status!: ReviewSessionItemStatusEnum;

  @AutoMap()
  seenOn!: Date | null;

  @AutoMap()
  durationMs!: number | null;
}

export class ReviewSessionSourceModel {
  @AutoMap()
  sourceId!: string;

  @AutoMap()
  title!: string;
}

export class ReviewSessionModel extends TBaseModel {
  @AutoMap()
  isSystemReminder!: boolean;

  @AutoMap()
  status!: ReviewSessionStatusEnum;

  @AutoMap()
  startedOn!: Date;

  @AutoMap()
  completedOn!: Date | null;

  @AutoMap()
  totalSeen!: number;

  @AutoMap()
  totalReviewed!: number;

  @AutoMap()
  totalSkipped!: number;

  @AutoMap()
  items!: ReviewSessionItemModel[];

  @AutoMap()
  sources!: ReviewSessionSourceModel[];
}


export class ReviewSessionCreateModel extends TBaseModel {
  @FormField({
    type: 'range',
    previewName: 'cards per session',
    default: 10,
    rangeStep: 1,
    rangeMinValue: 1,
    rangeMaxValue: 100,
    validators: [Validators.min(1), Validators.max(100)],
  })
  @AutoMap()
  cardCount!: number;

  @FormField({
    type: 'select',
    previewName: 'ordering type',
    selectTypeValues: Object.values(ReviewSessionOrderingTypeEnum).filter((v): v is number => typeof v === 'number') as number[],
    selectTypeEnumGeneralModelFunction: reviewSessionOrderingTypeEnumToGeneralTypeModel,
    default: ReviewSessionOrderingTypeEnum.Random,
    validators: []
  })
  @AutoMap()
  orderingType!: ReviewSessionOrderingTypeEnum;

  @FormField({
    type: 'multiLookup',
    previewName: 'sources',
    internalApiKey: INTERNAL_API_KEY_CONSTANTS.REVIEW_SESSION_SOURCE_MULTI_LOOKUP,
    default: [],
    validators: [],
  })
  @AutoMap(() => String)
  sourceIds!: string[];
}

export class ReviewSessionUpdateModel {
  @AutoMap()
  id!: string;

  @AutoMap()
  status!: ReviewSessionStatusEnum;

  @AutoMap()
  completedOn!: string | null;
}

export class ReviewSessionItemUpdateModel {
  @AutoMap()
  id!: string;

  @AutoMap()
  status!: ReviewSessionItemStatusEnum;

  @AutoMap()
  seenOn!: Date;

  @AutoMap()
  durationMs!: number;
}
